'use client';
// React
import { ReactElement } from 'react';
// Lib
import { SpinnerProps } from './spinner.interfaces';
import { Shape as ShapeStyled, Spinner as SpinnerStyled } from './spinner.styles';

const Spinner = (props: SpinnerProps): ReactElement => {
  const { color = 'tertiary', isVisible = true } = props;

  return (
    <SpinnerStyled {...props} isVisible={isVisible}>
      <ShapeStyled {...props} color={color} />
    </SpinnerStyled>
  );
};

export default Spinner;
